class LocalGraphQLClient {
  constructor(url) {
    this.url = url;
    this.ws = null;
    this.subscriptions = new Map();
    this.messageId = 0;
    this.pingInterval = null;
  }

  connect() {
    return new Promise((resolve, reject) => {
      this.ws = new WebSocket(this.url);

      this.ws.onopen = () => {
        this.ws.send(JSON.stringify({ type: 'connection_init' }));
        
        // Start keepalive ping every 3 seconds to prevent timeout
        this.pingInterval = setInterval(() => {
          if (this.ws && this.ws.readyState === WebSocket.OPEN) {
            this.ws.send(JSON.stringify({ type: 'ping' }));
          }
        }, 3000);
      };

      this.ws.onmessage = (event) => {
        const msg = JSON.parse(event.data);

        if (msg.type === 'connection_ack') {
          resolve();
        } else if (msg.type === 'data') {
          const subscription = this.subscriptions.get(msg.id);
          if (subscription) {
            subscription.callback(msg.payload.data);
          } else {
            console.warn('[LOCAL-GQL] No subscription found for id:', msg.id);
          }
        } else if (msg.type === 'pong') {
          // Keepalive pong received, connection is alive
        }
      };

      this.ws.onerror = (error) => {
        console.error('[LOCAL-GQL] Error:', error);
        reject(error);
      };

      this.ws.onclose = (event) => {
        console.warn('[LOCAL-GQL] Connection closed:', event.code, event.reason);
        // Clear ping interval on close
        if (this.pingInterval) {
          clearInterval(this.pingInterval);
          this.pingInterval = null;
        }
      };
    });
  }

  subscribe(query, variables, callback) {
    const id = String(++this.messageId);
    this.subscriptions.set(id, { callback });

    this.ws.send(JSON.stringify({
      type: 'start',
      id,
      payload: { query, variables }
    }));

    return {
      unsubscribe: () => {
        this.subscriptions.delete(id);
        this.ws.send(JSON.stringify({ type: 'stop', id }));
      }
    };
  }
}

export default LocalGraphQLClient;
